import CustomImage from 'components/common/CustomImage'
import './bottom.css'

export default function Bottom(){

    return (
        <footer className={"f"}>
            <div className={"f__t"}>
                <div className={"f__t__l"}>
                    <CustomImage src="/bottom-logo.png" />
                    <p>Mockuplabs.ai: Free mockup generator & design customizer. Simple, intuitive, and efficient.</p>
                </div>
                <div className={"f__t__r"}>
                    <div className={"f__t__c"}>
                        <p>Features</p>
                        <a href="/mockup" target={"_blank"}>Mockup Generator</a>
                        <a href="/smart-color-changer" target={"_blank"}>Smart Color Changer</a>
                        <a href="/all-over-print" target={"_blank"}>All-Over-Print(AOP)</a>
                        <a href="/ai-pattern-generator" target={"_blank"}>AI Pattern Generator</a>
                        <a href="/background-remover" target={"_blank"}>Background Remover</a>
                        <a href="/image-upscaler" target={"_blank"}>Image Upscaler</a>
                        <a href="/ai-eraser" target={"_blank"}>AI Eraser</a>
                        {/* 
                        
                        <a href="">Product mockup sets</a> */}
                    </div>
                    <div className={"f__t__c"}>
                        <p>User cases</p>
                        <a href="/create/t-shirt-mockup" target={"_blank"}>T-shirt Mockup</a>
                        <a href="/create/mug-mockup" target={"_blank"}>Mug Mockup</a>
                        <a href="/create/tote-bag-mockup" target={"_blank"}>Tote Bag Mockup</a>
                    </div>
                    <div className={"f__t__c"}>
                        <p>Resources</p>
                        <a href="/tutorials" target={"_blank"}>Tutorials</a>
                        {/* <a href="">Blog</a> */}
                        <a href="/contact" target={"_blank"}>Contact Us</a>
                        <a href="/pricing" target={"_blank"}>Pricing</a>
                    </div>
                </div>
            </div>
            <div className={"f__b"}>
                <span>© 2025 Mockuplabs.ai All rights reserved. </span>
                <a href="/termsofservice" target="_blank">Terms of Service</a>
                <a href="/privacy" target="_blank">Privacy Policy</a>
            </div>
        </footer>
    )
}